<template>
  <div class="examineManage">
    <!-- 搜索 -->
    <div class="key_top">
      <ul class="key_list">
        <li class="conditions_list_item">
          <span>申请人</span>
          <el-input v-model="search.name" @change="pageNumber=1,queryCostApplication()" placeholder="请输入" clearable>
          </el-input>
        </li>
        <li class="conditions_list_item">
          <span>申请日期</span>
          <span class="total_inp">
            <el-date-picker v-model="search.applyDate" @change="pageNumber=1,queryCostApplication()"
              type="datetimerange" placeholder="请选择"></el-date-picker>
          </span>
        </li>
        <li class="conditions_list_item">
          <span>状态</span>
          <el-select v-model="search.applyStatus" @change="pageNumber=1,queryCostApplication()" placeholder="不限"
            clearable>
            <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
        <li class="conditions_list_item">
          <span>请假或补卡时间</span>
          <span class="total_inp">
            <el-date-picker v-model="search.holidyDate" @change="pageNumber=1,queryCostApplication()"
              type="datetimerange" placeholder="请选择"></el-date-picker>
          </span>
        </li>
        <li class="conditions_list_item">
          <span>类型</span>
          <el-select v-model="search.holidayTypeName" @change="pageNumber=1,queryCostApplication()" placeholder="不限"
            clearable>
            <el-option v-for="(item,index) in holidayList" :key="index" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </li>
        <li class="conditions_list_item">
          <span>审批类型</span>
          <el-select v-model="search.type" @change="pageNumber=1,queryCostApplication()" placeholder="不限"
            clearable>
            <el-option v-for="(item,index) in examineHolidayList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </li>
      </ul>
      <div class="key_list" style="min-width: 390px">
        <el-button type="primary" @click="dialogVisible1=true">请假申请</el-button>
        <el-button type="primary" @click="dialogVisible=true">外勤申请</el-button>
        <el-button type="primary" @click="dialogVisible2=true">补卡申请</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="key_list_wrap sales_list_wrap">
      <el-table :data="list" border style="width: 100%" @row-click="rowColorclick" highlight-current-row
        :header-cell-style="setHeaderStyle" @row-dblclick="rowDetailShow">
        <el-table-column prop="holidayName" label="类型"></el-table-column>
        <el-table-column prop="applyEmployeeName" label="申请人"></el-table-column>
        <el-table-column prop="applyDate" label="申请时间"></el-table-column>
        <el-table-column prop="beginDatetime" label="请假或补卡时间"></el-table-column>
        <el-table-column prop="holidayNumber" label="时长（小时）"></el-table-column>
        <el-table-column prop="applyDemo" label="详情"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span :class="{rowColor:scope.row.id===isRowColor}"
              :style="scope.row.checkStatus=='已同意'?'color:#2CA203':scope.row.checkStatus=='审批中'?'color:rgb(255, 112, 0)':'color:#FF4726'"
              @click="detailShow(scope.row)">{{scope.row.checkStatus}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer_page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 30, 40]"
          layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <!-- 请假申请弹窗 -->
    <!-- 外勤 -->
    <LeaveRequest v-if="dialogVisible" :sta="dialogVisible" @cancel="dialogVisible=false,queryCostApplication()" />

    <!-- 请假 -->
    <FieldRequest v-if="dialogVisible1" :sta="dialogVisible1" @cancel="dialogVisible1=false,queryCostApplication()" />

    <!-- 补卡 -->
    <RepairCardRequest v-if="dialogVisible2" :sta="dialogVisible2"
      @cancel="dialogVisible2=false,queryCostApplication()" />

    <!-- 请假详情 -->
    <ExaminDetail v-if="dialogVisible3" :examinId="examinDate.id" :sta="dialogVisible3" :holidaystatus="holidaystatus"
      @cancel="dialogVisible3=false,queryCostApplication()" />

    <!-- 请假详情补卡 -->
    <examinCardDetail v-if="dialogVisible4" :examinId="examinDate.id" :sta="dialogVisible4"
      @cancel="dialogVisible4=false,queryCostApplication()" />
  </div>
</template>

<script>
import { storeFind } from "@/api/manageCenter";
import {
  addApplication,
  queryCostApplication,
  queryCostDetail,
  updateStatus,
  holidayQuery
} from "@/api/checkingIn";
import LeaveRequest from "./examinComponent/leaveRequestold";
import FieldRequest from "./examinComponent/fieldRequest";
import RepairCardRequest from "./examinComponent/repairCardRequest";
import ExaminDetail from "./examinComponent/examinDetail";
import examinCardDetail from "./examinComponent/examinCardDetail";
import { format } from "path";
import { getRouterLevel } from "@/vue/util/tool";

export default {
  // name: "审批管理",
  name: "/examineManage",
  components: {
    LeaveRequest,
    FieldRequest,
    RepairCardRequest,
    ExaminDetail,
    examinCardDetail
  },

  data() {
    let permisList = JSON.parse(sessionStorage.getItem("permisList"));
    return {
      permisList,
      isRowColor: "",
      search: {
        applyDate: [], //申请日期
        holidyDate: [], //请假或补卡时间
        name: "", //申请人编号
        applyStatus: "", //申请状态
        holidayTypeName: "", //请假类型编号
        type: "" //
      }, //搜索列表
      list: [], //审批管理列表
      examinDate: {},
      statusList: [
        {
          label: "审批中",
          value: "TO_BE_AUDITED"
        },
        {
          label: "已同意",
          value: "AUDITED"
        },
        {
          label: "已拒绝",
          value: "UNABLE"
        }
      ], //请假状态列表
      holidayList: [], //查询请假类型列表
      examineHolidayList: [
        {
          label: "待我审批",
          value: "1"
        },
        {
          label: "我已审批",
          value: "2"
        },
        // {
        //   label: "我发起的",
        //   value: "3"
        // },
      ], //审批类型列表
      total: 0, //每页条数
      currentPage: 1, //页数
      pageNumber: 1,
      pageSize: 20,
      dialogVisible: false, //导出弹框显示隐藏
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false
    };
  },
  mounted() {
    // this.getStoreList();
    this.queryCostApplication();
    this.holidayQuery();
    this.isRowColor = "";
  },
  activated() {
    this.queryCostApplication();
    this.holidayQuery();
    this.isRowColor = "";
  },
  methods: {
    permisShow(data) {
      // 权限配置
      let result = this.permisList.indexOf(data);
      if (result >= 0) {
        return true;
      } else {
        return false;
      }
    },

    rowColorclick(row) {
      this.isRowColor = row.id;
    },

    queryCostApplication() {
      let params = Object.assign(this.search, {});
      delete params.holidayTypeId;
      delete params.checkId;
      this.isRowColor = "";
      // 查询请假申请列表
      if (this.search.holidayTypeName) {
        let holidayTypeName = this.search.holidayTypeName;
        this.holidayList.map(item => {
          if (item.name == holidayTypeName) {
            if (item.id) {
              params.holidayTypeId = item.id;
            } else {
              params.checkId = item.checkId;
            }
          }
        });
      }

      params["page.pageNumber"] =
        this.pageNumber * this.pageSize - this.pageSize;
      params["page.pageSize"] = this.pageSize;
      let result = this.permisShow("审批管理查看");
      if (result >= 0) {
        params.permissionLevel = getRouterLevel("审批管理查看");
      }
      if(params.holidayTypeId){
        params.checkId = ''
      }
      this.$post(queryCostApplication, params).then(res => {
        if (res.success) {
          this.list = res.data;
          this.total = res.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    holidayQuery() {
      // 查询请假类型列表
      let params = {
        whetherOpen: "ALL"
      };
      this.$post(holidayQuery, params).then(res => {
        if (res.success) {
          this.holidayList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    detailShow(data) {
      this.examinDate = data;
      console.log(111, data);
      if (data.holidayName.indexOf("补卡") >= 0) {
        this.dialogVisible4 = true;
      } else {
        this.holidaystatus = data.holidayName;
        this.dialogVisible3 = true;
      }
    },

    rowDetailShow(row, column, event) {
      console.log(111, row);
      this.examinDate = row;
      if (row.holidayName.indexOf("补卡") >= 0) {
        this.dialogVisible4 = true;
      } else {
        this.holidaystatus = row.holidayName;
        this.dialogVisible3 = true;
      }
    },

    //分页
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.queryCostApplication();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNumber = 1;
      this.queryCostApplication();
    },
    //表单头部颜色
    setHeaderStyle() {
      return "background-color: #F2F4FF";
    },
    goto() {
      this.$router.push("attendanceStatistics");
    }
  }
};
</script>
<style lang="less">
.examineManage {
  .key_list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 10px 0;
    .conditions_list_item {
      padding: 5px 0 0 10px;
      display: flex;
      align-items: center;
      margin-right: 20px;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      > span {
        line-height: 20px;
        font-size: 12px;
        color: #666666;
        padding: 0;
        padding-right: 10px;
      }
      .el-input {
        width: 110px;
        height: 30px;
        
        .el-input-group__append,
        .el-input-group__prepend {
          padding: 0 10px;
          background: #cccccc;
          border: none;
        }

        .el-input__inner {
          height: 30px;
          border: 1px solid #dbdbdb;
        }

        .icon-icon_sousuo {
          color: white;
        }
      }
      .el-select {
        margin-left: 10px;
        .el-input {
          width: 100px;
          .el-input__inner {
            width: 100px;
            height: 30px;
            border: 1px solid #dbdbdb;
            color: black;
            padding: 0;
            padding-left: 10px;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
      .total_inp {
        border: none;
        display: flex;
        align-items: center;
        height: 30px;
        width: 220px;
        padding-right: 0;
        .el-date-editor {
          width: 220px;
          height: 30px;
          border: 1px solid #dbdbdb;
          .el-input__icon {
            line-height: 25px !important;
          }
          .el-range-separator{
            line-height: 25px;
          }
        }

        .el-range-input {
        }
      }
    }
  }
  .el-button--primary {
    margin-left: 30px;
    // margin-top: 20px;
    width: 100px;
    height: 30px;
    padding: 0;
    background: #5e75e6;
    border-color: #5e75e6;
  }
}
</style>
<style lang='less' scoped>
.examineManage {
  height: 100%;
  .el-table .cell,
  .el-table th div,
  .el-table--border td:first-child .cell,
  .el-table--border th:first-child .cell {
    text-align: center;
  }

  .key_top {
    display: flex;
    justify-content: space-between;
    align-items: top;
    padding: 10px 20px;
    background: #fff;

    .add_btn {
      width: 100px;
      height: 30px;
      background: #5e75e6;
      color: white;
      outline: none;
      border: none;
    }
  }

  .key_list_wrap {
    .el-dialog {
      width: 600px;

      .el-dialog__title {
        color: #5e75e6;
        font-size: 20px;
      }

      .el-dialog__close {
        font-size: 26px;
      }

      .el-dialog__body {
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
      }
    }

    .footer_page {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #5e75e6;
      }

      .el-pagination.is-background .btn-next,
      .el-pagination.is-background .btn-prev,
      .el-pagination.is-background .el-pager li {
        border: 1px solid #ccc;
        background: white;
      }
    }
  }
}
</style>